import type { SectionConfig } from '@shared/lib/page-sections/types';
import HeroSection from './HeroSection';
import RichTextSection from './RichTextSection';
import ImageWithTextSection from './ImageWithTextSection';
import CollectionGridSection from './CollectionGridSection';
import BannerSection from './BannerSection';
import SpacerSection from './SpacerSection';
import VideoSection from './VideoSection';
import FaqSection from './FaqSection';
import EmailCaptureSection from './EmailCaptureSection';
import ProductCarouselSection from './ProductCarouselSection';

/**
 * Dispatch a list of CMS sections to the matching component.
 * Unknown section types are silently dropped, keeps storefront from
 * crashing when admin schema gets ahead of a deployed client.
 */
export default function SectionRenderer({ sections }: { sections: SectionConfig[] }) {
  return (
    <>
      {sections.map((section) => {
        switch (section.type) {
          case 'hero':
            return <HeroSection key={section.id} section={section} />;
          case 'rich-text':
            return <RichTextSection key={section.id} section={section} />;
          case 'image-with-text':
            return <ImageWithTextSection key={section.id} section={section} />;
          case 'collection-grid':
            return <CollectionGridSection key={section.id} section={section} />;
          case 'banner':
            return <BannerSection key={section.id} section={section} />;
          case 'spacer':
            return <SpacerSection key={section.id} section={section} />;
          case 'video':
            return <VideoSection key={section.id} section={section} />;
          case 'faq':
            return <FaqSection key={section.id} section={section} />;
          case 'email-capture':
            return <EmailCaptureSection key={section.id} section={section} />;
          case 'product-carousel':
            return <ProductCarouselSection key={section.id} section={section} />;
          default:
            return null;
        }
      })}
    </>
  );
}
